import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

onMounted(() => {
  const access_token = localStorage.getItem("access_token");
  store.dispatch("setToken", access_token);
  if (process.env.NODE_ENV === "development") {
    onHandleInsertDevTool();
  }
});

/** 是否在 dingdev 模拟器 iframe 中（跨域 CDN 易失败，且模拟器自带调试能力） */
const isDingDevSimulator = () => {
  try {
    if (window.self === window.top) {
      return false;
    }
    const ref = document.referrer || "";
    return /127\.0\.0\.1:10003|localhost:10003|webSimulator|lyra/i.test(ref);
  } catch {
    return false;
  }
};

/**
 * 插入手机端开发调试工具
 * 使用 onload 初始化，避免 eruda 未定义报错
 */
const onHandleInsertDevTool = () => {
  if (isDingDevSimulator()) {
    return;
  }
  if ((window as any).eruda) {
    (window as any).eruda.init();
    return;
  }

  const script = document.createElement("script");
  script.src = "https://cdn.bootcdn.net/ajax/libs/eruda/2.3.3/eruda.js";
  script.async = true;
  script.onload = () => {
    try {
      if ((window as any).eruda) {
        (window as any).eruda.init();
      }
    } catch (error) {
      console.warn("[eruda] 初始化失败", error);
    }
  };
  script.onerror = () => {
    console.warn("[eruda] 脚本加载失败，已跳过移动端调试工具");
  };
  document.head.appendChild(script);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})